import React, { type ReactElement, useState } from "react";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

import Accordion from "@components/accordion";
import { primaryRipple } from "@utilities/helper";

const FAQ = (): ReactElement => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const toggleTab = (tabIndex: number): void => {
    setSelectedTab(selectedTab === tabIndex ? 0 : tabIndex);
  };

  return (
    <section className="mb-10">
      <h2 className="mb-5 text-center text-xl md:text-3xl">
        {t("frequently_asked_questions_title")}
      </h2>
      <div className="flex flex-col">
        <Accordion
          title={t("frequently_asked_questions_0")}
          description={t("frequently_asked_questions_answer_0")}
          isExpanded={selectedTab === 1}
          callbackOnClick={() => {
            toggleTab(1);
          }}
        />
        <Accordion
          title={t("frequently_asked_questions_1")}
          description={t("frequently_asked_questions_answer_1")}
          isExpanded={selectedTab === 2}
          callbackOnClick={() => {
            toggleTab(2);
          }}
        />
        <Accordion
          title={t("frequently_asked_questions_2")}
          description={t("frequently_asked_questions_answer_2")}
          isExpanded={selectedTab === 3}
          callbackOnClick={() => {
            toggleTab(3);
          }}
        />
      </div>
      <div className="mb-10 mt-4 flex flex-row flex-wrap items-center justify-center gap-1 sm:ml-4 sm:justify-start">
        <Trans
          i18nKey="learn_more_in_our_help_center"
          components={[
            <a
              href={process.env.GATSBY_FAQ_MORE_LINK}
              ref={primaryRipple}
              className="custom-link-btn-primary"
              target="_blank"
              aria-label="Help Center"
              rel="noreferrer"
            />,
          ]}
        />
      </div>
    </section>
  );
};
export default FAQ;
